var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{ref:"uploadExcel",attrs:{"auto-upload":false,"accept":".xlsx,.xls","on-change":_vm.fileChange,"show-file-list":false,"action":""}},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-upload2"}},[_vm._v("手动同步")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }